<template>
  <div>
    {{ alfakodo }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      alfakodo: {}
    }
  },
  beforeMount() {
    this.$axios.get('alfakodos/' + this.$route.params.id).then(res => {
      this.alfakodo = res.data
      return res.data
    })
  }
}
</script>